import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LaravelToken } from '../interfaces/laravel-token';

const AUTH_KEY = 'authToken';
const REFRESH_KEY = 'refreshToken';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  hasToken() {
    return !!this.getToken();
  }

  setToken(token) {
    window.localStorage.setItem(AUTH_KEY, token);
  }

  setRefreshToken(token) {
    window.localStorage.setItem(REFRESH_KEY, token);
  }

  getToken() {
    return window.localStorage.getItem(AUTH_KEY);
  }

  getRefreshToken() {
    return window.localStorage.getItem(REFRESH_KEY);
  }

  get accessKey() {
    return window.localStorage.getItem(AUTH_KEY);
  }

  get refreshKey() {
    return window.localStorage.getItem(REFRESH_KEY);
  }

  removeToken() {
    window.localStorage.removeItem(REFRESH_KEY);
    window.localStorage.removeItem(AUTH_KEY);
    return this.router.navigateByUrl('/auth/login');
  }

  refreshToken() {
    const refreshToken = this.getRefreshToken();
    const formData = new FormData();
    formData.append('grant_type', 'refresh_token');
    formData.append('refresh_token', refreshToken);
    formData.append('client_id', environment.clientId);
    formData.append('client_secret', environment.clientSecret);

    return this.http.post<LaravelToken>(environment.apiUrl + '/oauth/token', formData)
      .pipe(
        map(res => {
          this.setToken(res.access_token);
          this.setRefreshToken(res.refresh_token);
          return res.access_token;
        })
      );
  }
}
